import React from "react";
import useMobileBreakpoint from "@arctheme-hooks/useMobileBreakpoint";
import { Paragraph } from "@project-stories/elements/Paragraph/Paragraph";
import { Image } from "@project-stories/elements/Image/Image";
import "./BlogArticleTile.scss";

export const BlogArticleTile = ({
                                    article,
                                    show_excerpt = false,
                                    settings,
                                    isFeatured = false,
                                    showContent = true,
                                    showCategory = false,
                                    show_author = true,
                                    show_read_time = true
                                }) => {
    const isMobile = useMobileBreakpoint(settings.mobile_breakpoint);

    const charLimit = 90;
    const truncateText = (text, charLimit) => {
        return text.length <= charLimit ? text : text.substring(0, charLimit) + "...";
    };

    const getArticleImage = () => {
        if (typeof article.image === "object" && article.image.src) {
            return article.image.src;
        } else if (typeof article.image === "string") {
            return article.image;
        }
    }

    const getArticleUrl = () => {
        let articleUrl = `/blogs/${article.handle}`;
        if (article.blog?.handle && !article.handle.includes(article.blog.handle)) {
            articleUrl = `/blogs/${article.blog.handle}/${article.handle}`;
        } else if (settings?.blog?.handle && !article.handle.includes(settings.blog.handle)) {
            articleUrl = `/blogs/${settings.blog.handle}/${article.handle}`;
        }
        return articleUrl;
    };

    const article_url = getArticleUrl();
    const article_image = getArticleImage();

    let category = "";
    if (showCategory && article?.tags?.length) {
        const tag = article.tags.find((item) => item.includes("category:"));
        if (tag) category = tag.split("category:")[1];
    }

    const wordsPerMinute = 200;
    const text = article.content || "";
    console.log("Article content:", text);
    const wordCount = text.split(/\s+/).length;
    console.log("Article wordcount:", wordCount);
    article.readTime = Math.ceil(wordCount / wordsPerMinute);
    
    article.date = article.published_at;
    article.authorName = article.author;
    article.authorImage = 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR4g_2Qj3LsNR-iqUAFm6ut2EQVcaou4u2YXw&s';

    return (
        <div className="blog-article-tile">
            <a href={article_url} className="blog-article-tile__image-container">
                <Image
                    imageUrl={article_image}
                    classes="blog-article-tile__image"
                />
            </a>

            <div className="blog-article-tile__details">
                <div className="blog-article-tile__text-group">
                    {showCategory && category && <Paragraph text={category} type="blog-article-tile__category" />}

                    <div className="blog-article-tile__header text-left">
                        <Paragraph
                            text={article.title}
                            type={`blog-article-tile__title ${isMobile ? "h6" : "h6"}`}
                        />
                        {isFeatured && (
                            <a href={article_url} className="blog-article-tile__read-more">
                                Read More
                            </a>
                        )}
                    </div>
                </div>

                {showContent && (
                    <div className="blog-article-tile__content">
                        <Paragraph text={show_excerpt ? truncateText(article.excerpt || "", charLimit) : ""} />
                    </div>
                )}

                <div className="blog-article-tile__meta flex gap-4 pt-4">
                    {show_author && (
                        <Image
                            imageUrl={article.authorImage}
                            classes="blog-article-tile__author-image rounded-full h-[40px] w-[40px]"
                        />
                    )}
                    <div className={`flex flex-col`}>
                        {show_author && (
                            <Paragraph text={article.authorName} type="blog-article-tile__author-name" />
                        )}
                        <div className="flex gap-2">
                            <Paragraph text={article.date} type="blog-article-tile__date" />
                            {show_read_time && (
                                <>
                                    <span>•</span>
                                    <Paragraph text={`${article.readTime} min read`} type="blog-article-tile__read-time" />
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BlogArticleTile;
